export const cookies = {
    USER_COOKIE_NAME: 'userCookie',
    HMID_COOKIE_NAME: 'hmid',
    UTAG_MAIN_COOKIE_NAME: 'utag_main',
    AEM_SEGS_COOKIE_NAME: 'aemsegs',
    AAM_GA_SEGS_COOKIE_NAME: 'aamgasegs',
    CP_SEGS_COOKIE_NAME: 'cpsegs',
};
//# sourceMappingURL=cookies.js.map